<app-breadcrumbs [headerTitle]="'CALENDAR'" />
<div class="main-container">
	<app-customer-list
		[payGroupStatuses]="'LIVE, IMPLEMENTATION'"
		(newCustomerSelectedEvent)="customerSelected($event)"
	></app-customer-list>
</div>
